import { useEffect, useState } from 'react';
import { ReactEditor, useSlate } from 'slate-react';

const useSize = element => {
    const [size, setSize] = useState({ height: 0, width: 0 });
    const editor = useSlate();

    useEffect(() => {
        const elementTarget = ReactEditor.toDOMNode(editor, element);
        const observer = new ResizeObserver(entries => {
            const { height, width } = elementTarget.getBoundingClientRect();
            setSize({ height, width });
        });
        observer.observe(elementTarget);

        return () => {
            observer.disconnect();
        };
    }, [element]);
    return size;
};

export default useSize;
